import * as React from 'react';
import { components } from 'react-select';
import { Text } from '../../../Text';
export const NoOptionsMessage = (internalProps) => {
    return (React.createElement(components.NoOptionsMessage, Object.assign({}, internalProps),
        React.createElement(Text, { ellipsis: true }, internalProps.selectProps.t('common:not_found'))));
};
//# sourceMappingURL=NoOptionsMessage.js.map